import { createContext } from "react";

//Types
import { MapConfigContexType } from "@/@types/context/MapConfigContext";

const MapConfigContext = createContext<MapConfigContexType | null>(null);

MapConfigContext.displayName = "MapConfigContext";
export default MapConfigContext;
